import { ButtonProps } from '../../atoms/Button';
import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';

type ToastNotificationInternalProps = {
  icon?: IconProps;
  text?: TextProps;
  button?: ButtonProps;
};

type ToastNotificationPropsValues = {
  'Critical': ToastNotificationInternalProps;
  'Info': ToastNotificationInternalProps;
  'Positive': ToastNotificationInternalProps;
  'Warning': ToastNotificationInternalProps;
};

const propValues: ToastNotificationPropsValues = {
  'Critical': {
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    button: {
      type: 'ComponentIcon',
      size: 'S',
      styleType: 'Positive',
      state: 'Default',
    },
  },
  'Info': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPositiveHover',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    button: {
      type: 'ComponentIcon',
      size: 'S',
      styleType: 'Positive',
      state: 'Default',
    },
  },
  'Positive': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPositiveHover',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    button: {
      type: 'ComponentIcon',
      size: 'S',
      styleType: 'Positive',
      state: 'Default',
    },
  },
  'Warning': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPositiveHover',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    button: {
      type: 'ComponentIcon',
      size: 'S',
      styleType: 'Positive',
      state: 'Default',
    },
  },
};

const getProps = (type: string): ToastNotificationInternalProps => {
  const values: ToastNotificationInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
